<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
      <!-- eslint-disable-next-line max-len -->
      <v-tab v-for="tab of tabs" class="common-font-size" :key="tab.id" @click="WarnUser(tab.to)" :id="`mtgTransSequenceTab${tab.id}`"
        :class="`mtg-trans-sequence-tab-${tab.id}`">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import '../assets/style.css';
import CommonDropDowns from '../components/tax/common-utils/CommonDropDowns.mixin.vue';

export default {
  name: 'TaxDelinquent',
  components: {
  },
  mixins: [CommonDropDowns],
  created() {
    this.getPathName();
    this.loadDropDownList();
  },
  updated() {
    this.getPathName();
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/tax/delinquent/juneResale/resalepropertylist' }, caption: 'June Resale' },
      { id: 2, to: { path: '/tax/delinquent/personalTaxWarrants/taxWarrants' }, caption: 'Personal Tax Warrants' },
      { id: 3, to: { path: '/tax/delinquent/commissionerssale/commissionerspropertylist' }, caption: 'Commissioners Property List' },
    ],
  }),
  methods: {
    getPathName() {
      const curPath = this.$route.path;
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      if (ftr.length) this.activetab = ftr[0].id - 1;
      else if (curPath.includes('personalTaxWarrants')) this.activetab = 1;
      else if (curPath.includes('commissionerssale')) this.activetab = 2;
      else this.activetab = 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
    ...mapActions('tax/taxCommon', ['loadTaxYearList']),
    ...mapActions('tax/juneResale', ['loadSaleYearList']),
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions('tax/taxPayment', [
      'loadPaymentsWkstList',
    ]),
    handleLoadWarrantStatus() {
      const criteria = {
        isTaxWarrant: true,
      };
      this.loadTaxStatusCodesSharedRecords(
        {
          criteria,
          baseCrudKey: 'taxWarrantStatus',
          isItSetState: true,
          postProcessTrans: this.postProccessStatusCodesData,
        },
      );
    },
    loadDropDownList() {
      this.loadConfig({ requiredScope: 'taxConfig' });
      this.loadConfig({ requiredScope: 'resaleConfig' });
      this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      this.loadSaleYearList({ postProcessTrans: this.postProccessSaleYearData });
      this.handleLoadWarrantStatus();
      this.loadTaxFeeMasterTypes({
        criteria: { sortBy: [{ column: 'feeNumber', direction: 'asc' }] },
        postProcessTrans: this.postProccessTaxFeeData,
        baseCrudKey: 'sharedTaxFeeMaster',
      });
      this.loadPaymentsWkstList();
    },
    postProccessSaleYearData(items) {
      const updatedItems = [];
      for (let i = 0; i < (items || []).length; i += 1) {
        updatedItems.push({ name: items[i], value: items[i] });
      }
      return updatedItems;
    },
  },

};
</script>
